import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/index';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { AnythingElseWeShouldKnowPage } from './pages/AnythingElseWeShouldKnowPage';
import { BeforeYouStartPage } from './pages/BeforeYouStartPage';
import { CallUsPage } from './pages/CallUsPage';
import { DoYouWantConfirmationEmail } from './pages/DoYouWantConfirmationEmail';
import { HasDamageCausedInjuryPage } from './pages/HasDamageCausedInjuryPage';
import { ReportSubmittedPage } from './pages/ReportSubmittedPage';
import { TestLandingPage } from './pages/TestLandingPage';
import { UploadPhotoPage } from './pages/UploadPhotoPage';
import { WhatIsCausingTheIssuePage } from './pages/WhatIsCausingTheIssuePage';
import { WhereIsTheRoadDamageLocatedPage } from './pages/WhereIsTheRoadDamageLocatedPage';
import { YourDetailsPage } from './pages/YourDetailsPage';
import { ReportToTflPage } from './pages/ReportToTflPage';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { NotFoundErrorTemplate, InternalServerErrorTemplate } from '@templates';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);

  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

export function Pages() {
  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route
            path={RoutesList.TEST_LANDING_PAGE}
            element={<TestLandingPage />}
          />
          <Route
            path={RoutesList.HIGHWAYS_HOME}
            element={<BeforeYouStartPage />}
          />
          <Route
            path={RoutesList.HIGHWAYS_DAMAGE}
            element={<HasDamageCausedInjuryPage />}
          />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhotoPage />} />
          <Route
            path={RoutesList.HIGHWAYS_DAMAGE_TYPE}
            element={<WhatIsCausingTheIssuePage />}
          />
          <Route
            path={RoutesList.ISSUE_LOCATION}
            element={<WhereIsTheRoadDamageLocatedPage />}
          />
          <Route path={RoutesList.TFL_REPORT} element={<ReportToTflPage />} />
          <Route
            path={RoutesList.ANYTHING_ELSE}
            element={<AnythingElseWeShouldKnowPage />}
          />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetailsPage />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<DoYouWantConfirmationEmail />}
          />
          <Route path={RoutesList.CALL_US} element={<CallUsPage />} />
          <Route
            path={RoutesList.CONFIRMATION}
            element={<ReportSubmittedPage />}
          />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          {/* this is added to prevent 404 error when redirect */}
          <Route path={RoutesList.CALLBACKS} element={null} />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}
// Component to track route changes and log page views
export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
